import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Credit } from 'models/CreditModel';
import AsyncSelect from 'react-select/async';
import { useSearchParams } from 'react-router-dom';

const CreditForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.CREDIT, Code.Form.Name.CREDIT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [formData, setFormData] = useState<Credit>({});
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();

   const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const typeId = searchParams.get(Code.UrlPara.Type);
   
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.Http(Code.File.CREDIT, Code.Option.Common.SELECT, setTypeOptions, setError);
   
    API.Data.GetByKeyId<Credit>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.credit_active); 
        const clientData = await API.Data.getClientNameNumber(data.client_id);
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
          ...clientData,
        }));
        setLoading(false);
      }})
      
      const onNewEntry = async () => {
        if(keyId===Code.Key.NEW && clientId) {
          const clientName = await API.Data.GetClientName(Number(clientId));
          const newData = {
            client_id: Number(clientId),
            client_name: Utility.Value.Text(clientName), 
            type_id: typeId ? Number(typeId) : undefined,
          };
          setFormData(newData);
        }
        setLoading(false);
      };
      onNewEntry();
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      credit_amount: formData.type_id === 40 ? Math.abs(formData.credit_amount || 0) : -Math.abs(formData.credit_amount || 0)
    });

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} clientNumber={formData.client_number} formName={formName} Privilege={Privilege} />
          <Control.Tab.Header titles={["Credit Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
           
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Credit.Date} value={formData.credit_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} currentDate={true} />
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Header id={Name.Client.Id} title={Title.Client} require={true}>
                  <AsyncSelect id={Name.Client.Id} loadOptions={(inputValue) => API.Data.AsyncOption(inputValue, Code.Form.Name.CLIENT, Code.Mapping.client.value, Code.Mapping.client.label)} styles={Code.Style.FormOption} onChange={(selected) => Utility.Handle.ClientChange(selected, setFormData)} value={Utility.Value.Async(formData.client_id,formData.client_name)} placeholder="Search" />
                </Field.Header>
              </Control.Row>
              <Control.Row>
                <Field.Amount id={Name.Credit.Amount} value={formData.credit_amount} title={Title.Amount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} />
                <Field.Text id={Name.Credit.RefNo} value={formData.credit_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
              <Control.Box>
                <Field.Area id={Name.Credit.Comment} value={formData.credit_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
              </Control.Box>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default CreditForm;